import { gql } from 'graphql-tag';

export const CLEAR_SESSION = gql`
  mutation {
    clearSession
  }
`;
